import cookieService from 'services/cookies'
import { DEFAULT_LANGUAGE, isSupportedLanguage, Language, SupportedLanguages } from 'utils/languages'

const isBrowser = typeof window !== 'undefined'

export const getLangFromCookie = (): Language | null => {
  if (!isBrowser) return null

  try {
    const cookieLang = cookieService?.getItem('language')
    return isSupportedLanguage(cookieLang) ? cookieLang : null
  } catch (error) {
    console.error('Error getting language from cookie:', error)
    return null
  }
}

export const getLangFromUrl = (): Language | null => {
  if (!isBrowser) return null
  const hostname = window.location.hostname
  if (hostname.startsWith('en.')) return SupportedLanguages.en
  if (hostname.startsWith('ru.')) return SupportedLanguages.ru
  if (hostname.startsWith('ua.')) return SupportedLanguages.ua
  return SupportedLanguages.pl
}

export const getServerLanguage = (): Language | null => {
  const langFromEnv = process?.env?.LANGUAGE
  if (!langFromEnv) return null
  return isSupportedLanguage(langFromEnv) ? langFromEnv : null
}

const getInitialLanguage = (): Language | null => getLangFromCookie() || getLangFromUrl()

export function getCurrentLanguage(): Language {
  const detectedLang = !isBrowser ? getServerLanguage() : getInitialLanguage()

  if (detectedLang) return detectedLang

  const source = !isBrowser ? 'server environment' : 'cookie or URL'
  console.warn(`[getCurrentLanguage] Could not get language from ${source}, using default language:`, DEFAULT_LANGUAGE)
  return DEFAULT_LANGUAGE
}
